import { InferType } from 'yup'
import { imageComponentSchema } from './imageComponentSchema'

export const galleryImageComponentSchema = imageComponentSchema

export type GalleryImageComponent = InferType<
  typeof galleryImageComponentSchema
>
